export type SeoRoute = {
  path: string;
  title: string;
  description: string;
  priority?: number;
  changefreq?: "monthly" | "yearly";
  indexable: boolean;
};

export const SITE_URL = "https://dennisvalchez.com";

export const SEO_ROUTES: readonly SeoRoute[] = [
  {
    path: "/",
    title: "Dennis Valchez — Psychic, Medium & Tarot Reader, Sydney",
    description:
      "Get your clarity with my reading. Live tarot, psychic & mediumship sessions on Zoom and in-person in Sydney. Book a session today.",
    priority: 1.0,
    changefreq: "monthly",
    indexable: true,
  },
  {
    path: "/decks",
    title: "Tarot Decks — Dennis Valchez",
    description:
      "Heaven's Bridge decks by Dennis Valchez: spiritual tools for mediumship, guidance and emotional connection, in two complementary editions.",
    priority: 0.8,
    changefreq: "monthly",
    indexable: true,
  },
  {
    path: "/spirit-box",
    title: "Heaven's Bridge Spirit Box — Dennis Valchez",
    description:
      "A custom-built AM/FM spirit box for paranormal investigation, ITC and EVP sessions. Three antenna modes, adjustable sweep speed, USB-C. $450 AUD.",
    priority: 0.8,
    changefreq: "monthly",
    indexable: true,
  },
  {
    path: "/digital-tarot-insight",
    title: "Digital Tarot Insight — Dennis Valchez",
    description:
      "A personalised written tarot reading delivered to your inbox. Order a Digital Tarot Insight from psychic medium Dennis Valchez.",
    priority: 0.7,
    changefreq: "monthly",
    indexable: true,
  },
  {
    path: "/live-tarot",
    title: "Live Tarot Reading — Dennis Valchez",
    description:
      "Book a live tarot reading with Dennis Valchez on Zoom, available worldwide. Clear, compassionate guidance for the questions that matter.",
    priority: 0.7,
    changefreq: "monthly",
    indexable: true,
  },
  {
    path: "/live-psychic",
    title: "Live Psychic Reading — Dennis Valchez",
    description:
      "Book a live psychic reading with Dennis Valchez on Zoom, available worldwide. Intuitive insight into love, career and life direction.",
    priority: 0.7,
    changefreq: "monthly",
    indexable: true,
  },
  {
    path: "/live-mediumship",
    title: "Live Mediumship Reading — Dennis Valchez",
    description:
      "Book a live mediumship reading with Dennis Valchez to connect with loved ones in spirit. Available worldwide on Zoom.",
    priority: 0.7,
    changefreq: "monthly",
    indexable: true,
  },
  {
    path: "/in-person",
    title: "In-Person Reading, Sydney — Dennis Valchez",
    description:
      "Sit with Dennis Valchez for a private in-person psychic and mediumship reading in Sydney. A grounded, face-to-face session.",
    priority: 0.7,
    changefreq: "monthly",
    indexable: true,
  },
  {
    path: "/events",
    title: "Events & Parties — Dennis Valchez",
    description:
      "Bring live tarot readings to your private or corporate event with Dennis Valchez. Enquire about availability across Australia.",
    priority: 0.6,
    changefreq: "monthly",
    indexable: true,
  },
  {
    path: "/sacred-visit",
    title: "Sacred Visit — Dennis Valchez",
    description:
      "A private cemetery visit and video tribute with Dennis Valchez, honouring loved ones resting in Sydney cemeteries. Enquire about a Sacred Visit.",
    priority: 0.7,
    changefreq: "monthly",
    indexable: true,
  },
  {
    path: "/guidance",
    title: "Guidance Edition Tarot Deck — Dennis Valchez",
    description:
      "The Heaven's Bridge Guidance Edition tarot deck by Dennis Valchez. Buy the physical deck or try an instant online reading for $5.",
    priority: 0.7,
    changefreq: "monthly",
    indexable: true,
  },
  {
    path: "/mediumship",
    title: "Mediumship Tarot Deck — Dennis Valchez",
    description:
      "The Heaven's Bridge Mediumship tarot deck by Dennis Valchez. Buy the physical deck or try an instant online reading for $5.",
    priority: 0.7,
    changefreq: "monthly",
    indexable: true,
  },
  {
    path: "/bundle",
    title: "Tarot Deck Bundle — Dennis Valchez",
    description:
      "Get both Heaven's Bridge tarot decks — Guidance Edition and the Mediumship Deck — together with free worldwide shipping.",
    priority: 0.7,
    changefreq: "monthly",
    indexable: true,
  },
  {
    path: "/reading",
    title: "Instant Reading — Dennis Valchez",
    description:
      "Pick a deck, draw three cards, and receive a personalised written message. Instant online readings with the Heaven's Bridge decks, $5 AUD.",
    priority: 0.7,
    changefreq: "monthly",
    indexable: true,
  },
  {
    path: "/card-of-the-day",
    title: "Card of the Day — Dennis Valchez",
    description:
      "Draw your free card of the day from the Heaven's Bridge decks. A daily message from psychic medium Dennis Valchez — one card, once a day.",
    priority: 0.7,
    changefreq: "monthly",
    indexable: true,
  },
  {
    path: "/reviews",
    title: "Client Reviews — Dennis Valchez",
    description:
      "Verified client reviews for tarot, psychic and mediumship readings with Dennis Valchez. Read what people say, filter by service, and see Dennis's replies.",
    priority: 0.6,
    changefreq: "monthly",
    indexable: true,
  },
  {
    path: "/terms-and-conditions",
    title: "Terms & Conditions — Dennis Valchez",
    description:
      "Terms and conditions for tarot, psychic and mediumship sessions booked with Dennis Valchez.",
    priority: 0.3,
    changefreq: "yearly",
    indexable: true,
  },
  {
    path: "/privacy-policy",
    title: "Privacy Policy — Dennis Valchez",
    description:
      "How Dennis Valchez collects, uses and protects your personal information when booking a reading.",
    priority: 0.3,
    changefreq: "yearly",
    indexable: true,
  },
  {
    path: "/return-policy",
    title: "Return Policy — Dennis Valchez",
    description:
      "Refunds and rescheduling policy for sessions booked with Dennis Valchez.",
    priority: 0.3,
    changefreq: "yearly",
    indexable: true,
  },
  {
    path: "/warranty-policy",
    title: "Warranty Policy — Dennis Valchez",
    description:
      "Warranty terms for products purchased from Dennis Valchez.",
    priority: 0.3,
    changefreq: "yearly",
    indexable: true,
  },
  {
    path: "/design-system",
    title: "Design System (internal)",
    description: "Internal design system reference.",
    indexable: false,
  },
  {
    // Link-only page (shared directly, not in navigation or the sitemap).
    path: "/subscribe",
    title: "Heaven's Bridge — Free Guide by Dennis Valchez",
    description:
      "Get Heaven's Bridge — a free beginner's guide to mediumship, intuition " +
      "and spirit communication by Dennis Valchez, delivered as a PDF.",
    indexable: false,
  },
  {
    // Utility page linked from the footer, not meant for search results.
    path: "/verify",
    title: "Verify Your Device — Dennis Valchez",
    description:
      "Check that your Heaven's Bridge Spirit Box is original using its device " +
      "number and secret code.",
    indexable: false,
  },
  {
    // Printed as a QR code in every Spirit Box box: the path must never change.
    path: "/spirit-box-user-manual",
    title: "Spirit Box User Guide — Dennis Valchez",
    description:
      "Download the Heaven's Bridge Spirit Box user guide as a printable A4 PDF " +
      "in your language: English, Русский, Español, Français, 日本語 and more.",
    priority: 0.4,
    changefreq: "monthly",
    indexable: true,
  },
  {
    path: "/cards/guidance",
    title: "Guidance Deck — Card Meanings",
    description: "Browse every Guidance Deck card and its meaning.",
    priority: 0.6,
    changefreq: "monthly",
    indexable: true,
  },
  {
    path: "/cards/mediumship",
    title: "Mediumship Deck — Card Meanings",
    description: "Browse every Mediumship Deck card and its meaning.",
    priority: 0.6,
    changefreq: "monthly",
    indexable: true,
  },
];

export function routeFor(path: string): SeoRoute | undefined {
  return SEO_ROUTES.find((r) => r.path === path);
}
